module.exports = __webpack_public_path__ + "static/media/ic_open_in_new.c0be18e9.svg";